import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgJam = function SvgJam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17 3.458A8.187 8.187 0 0 1 6.343 1.23C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263a8.178 8.178 0 0 1 3.14 2.194L17.335 16 28.83 28.541a8.187 8.187 0 0 1-3.172 2.23C23.566 31.6 19.75 31.965 16 32c-3.75-.034-7.567-.432-9.657-1.23a8.187 8.187 0 0 1-3.172-2.229L14.667 16 3.17 3.458Z",
    fill: "#1AAF5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.158 27.175 27.254 2.08c1.163.78 2 1.784 2.596 2.738L4.74 29.927c-1.159-.788-1.992-1.797-2.582-2.752Z",
    fill: "#F2C500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.26 29.927 2.159 4.825c.59-.955 1.423-1.964 2.581-2.753l25.103 25.103c-.59.955-1.423 1.964-2.581 2.752Z",
    fill: "#F2C500"
  }));
};

export default SvgJam;